"use strict";

exports.__esModule = true;
exports.LAYOUT_TYPE_COMPACT = exports.LAYOUT_TYPE_CLASSIC = exports.LAYOUT_TYPE_PINBOARD = void 0;
var LAYOUT_TYPE_PINBOARD = 0;
exports.LAYOUT_TYPE_PINBOARD = LAYOUT_TYPE_PINBOARD;
var LAYOUT_TYPE_CLASSIC = 1;
exports.LAYOUT_TYPE_CLASSIC = LAYOUT_TYPE_CLASSIC;
var LAYOUT_TYPE_COMPACT = 2;
exports.LAYOUT_TYPE_COMPACT = LAYOUT_TYPE_COMPACT;